'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".ErrorAPI-module_errorContainer__ppoYz{display:block;text-align:center}.ErrorAPI-module_errorContainerLandscape__Qn-B5{display:table-cell;text-align:left}";
var styles = {"errorContainer":"ErrorAPI-module_errorContainer__ppoYz","errorContainerLandscape":"ErrorAPI-module_errorContainerLandscape__Qn-B5"};
styleInject["default"](css_248z, 'f5875c12-8112-400a-9930-47a91dfe2340');

exports["default"] = styles;
